<div class="dashboardAccounts">
    <div class="links">
        <a [routerLink]="['/dashboard/bookings/requests']" routerLinkActive="router-link-active">Booking Requests</a>

        <a [routerLink]="['/dashboard/bookings/approved']" routerLinkActive="router-link-active">Approved Bookings</a>

        <a [routerLink]="['/dashboard/bookings/denied']" routerLinkActive="router-link-active">Denied Bookings</a>

        <a [routerLink]="['/dashboard/bookings/past-bookings']" routerLinkActive="router-link-active">Past Bookings</a>
    </div>
</div>

<div class="subSection">
    <div class="requests">
        <div class="title">Denied Bookings</div>
    </div>
    <div class="resultsWrapper">

        <div class="resultsWrapper" *ngIf="hashmap.size && isLoaded">

            <!-- <div class="days" *ngFor="let dayList of hashmap">
            <div class="dayTitle">
                test {{dayList}}
            </div>
        </div> -->

            <div class="row" *ngFor="let entry of hashmap.entries() ">
                <!-- <h2>Key: {{ entry[0] }}</h2> -->
                <div class="dayTitle">
                    {{entry[0]}}
                </div>

                <div class="list">
                    <app-dash-booking-card [booking]="request" *ngFor="let request of entry[1]"></app-dash-booking-card>

                    <!-- <div class="item" >
                        <div class="itemBox">

                            <div class="posterHolder">
                                <div class="poster">
                                    <img [src]="request.movie?.Poster" alt="">
                                </div>
                            </div>

                            <div class="infoHolder">

                                <div class="name">
                                    {{request.movie?.Title }}
                                </div>


                                <div class="split">
                                    <div class="left">
                                        <div class="label">
                                            start date
                                        </div>
                                        <div class="address">
                                            {{request.startDate.toDate() | momentFormat:"DD/MM/YY"}}
                                        </div>
                                    </div>
                                    <div class="righ">
                                        <div class="label">
                                            end date
                                        </div>
                                        <div class="address">
                                            {{request.endDate.toDate()| momentFormat:"DD/MM/YY"}}
                                        </div>
                                    </div>
                                </div>


                                <div class="label">
                                    format
                                </div>
                                <div class="address">
                                    {{request.format}}
                                </div>

                                <div class="split">
                                    <div class="left">
                                        <div class="label">
                                            city
                                        </div>
                                        <div class="address">
                                            {{request.city}}
                                        </div>
                                    </div>
                                    <div class="righ">
                                        <div class="label">
                                            state
                                        </div>
                                        <div class="address">
                                            {{request.state}}
                                        </div>
                                    </div>
                                </div>

                                <div class="label">
                                    booked by
                                </div>
                                <div class="person">
                                    {{request.userName}}
                                </div>
                            </div>
                        </div>

                       
                    </div> -->
                </div>

            </div>
        </div>
    </div>